var formatSnakeCaseToSentenceCase = function (input) {
    var words = input.split('_');
    var firstWord = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
    var formattedWords = words.slice(1).map(function (word) { return word.toLowerCase(); });
    return "".concat(firstWord, " ").concat(formattedWords.join(' '));
};
export default formatSnakeCaseToSentenceCase;
//# sourceMappingURL=formatSnakeCaseToSentenceCase.js.map